import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import cookie from 'react-cookies';
import { isEmpty, intersectionBy } from 'lodash';
import {
	AppAside,
	AppBreadcrumb,
	AppFooter,
	AppHeader,
	AppSidebar,
	AppSidebarFooter,
	AppSidebarForm,
	AppSidebarHeader,
	AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import { adminNav } from '../../_nav';
// routes config
import routes from '../../routes';
import subAdminRoutes from '../../subAdminRoutes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { adminRoles, apiBaseUrl } from '../../configs/configs';
import { removeCookies } from '../../helper/helper';
import IdleTimer from 'react-idle-timer';

class DefaultLayout extends Component {
	constructor(props) {

		super(props);
		this.state = {
			adminType: '',
			accessRoutes: [],
			accessNavs: { items: [] },
			isLogout: false,
			accessModules: '',
			timeout:1000 * 60 * 15,
			// timeout: 1000 * 60 * 0.	5,
			showModal: false,
			userLoggedIn: false,
			isTimedOut: false

		};
		this.adminId = cookie.load('adminId');
		this.idleTimer = null;
		this.onAction = this._onAction.bind(this);
		this.onActive = this._onActive.bind(this);
		this.onIdle = this._onIdle.bind(this);

	}
	componentDidMount() {
		this.getAdminProfile();
	}

	_onAction(e) {
		this.setState({ isTimedOut: false })
	}

	_onActive(e) {
		this.setState({ isTimedOut: false })
	}

	_onIdle(e) {
		const isTimedOut = this.state.isTimedOut

		if (isTimedOut) {
			this.setState({ isLogout: true });
		} else {
			this.idleTimer.reset();
			this.setState({ isTimedOut: true })
		}
	}

	async getAdminProfile() {
		const token = cookie.load('token');

		if (token) {
			const getUserDataApi = `${apiBaseUrl}/admin/list?id=${this.adminId}`;
			const response = await fetch(getUserDataApi, {
				headers: {
					"token": token,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			});

			if (response.status === 200) {
				const res = await response.json();
				let adminData = res.result;
				// console.log('adminData', adminData);
				cookie.save('adminType', adminData.type || '');
				cookie.save('subadminType', adminData.subadmin_type || '');

				if (adminData.type === 'admin') {
					this.setState({ adminType: adminData.type || '', loading: false, accessRoutes: routes, accessNavs: adminNav });
				} else {
					cookie.save('accessModules', adminData.accessModules);
					let cookiemodules = (adminData.accessModules && adminData.accessModules.split(',')) || [];

					let modulesObjectArray = cookiemodules.map((m) => { return { module: m } });

					let xroutes = [];
					let xnavs = intersectionBy(adminNav.items, modulesObjectArray, 'module') || [];

					xnavs.map((nav) => {
						routes.map((route) => {
							if (route.path && (route.path.indexOf(nav.url) > -1)) {
								xroutes.push(route);
							} else if (route.path && ((route.path.indexOf('/password') > -1) || (route.path.indexOf('/profile') > -1) || (route.path.indexOf('/football_contests_schedule') > -1) || (route.path.indexOf('/live-fantasy-contests-schedule') > -1) || (route.path.indexOf('/kabaddi_contests_schedule') > -1) || (route.path.indexOf('/schedule') > -1) || (route.path.indexOf('/revenue') > -1) || (route.path.indexOf('/match') > -1) || (route.path.indexOf('/other-games') > -1) || (route.path.indexOf('/add_breakup/prediction') > -1) || (route.path.indexOf('/user_winning') > -1) || (route.name === 'Home') || (route.path.indexOf('/opinion_trading') > -1) || (route.path.indexOf('/opinion-trading-details') > -1) || (route.path.indexOf('/in_play') > -1) )) {
								// adding common routes
								xroutes.push(route);
							}
						});
					});
					this.setState({
						adminType: adminData.type || '',
						loading: false,
						accessRoutes: xroutes,
						accessNavs: { items: xnavs }
					});
				}
			} else if (response.status === 401) {
				cookie.remove('token');
				return <Redirect to='/login' />
			} else {
				this.setState({ loading: false });
				return new Error();
			}
		} else {
			let xroutes = [];
			let xnavs = [];

			//adding common routes
			xnavs.push(
				{
					url: '/password',
				}
			);

			xnavs.map((nav) => {
				routes.map((route) => {
					if (route.path && (route.path.indexOf(nav.url) > -1)) {
						xroutes.push(route);
					}
				});
			});

			this.setState({
				loading: false,
				accessRoutes: xroutes,
				accessNavs: { items: xnavs }
			});

			this.setState({ isLogout: true });
		}
	}

	render() {
		let routeContainer = !isEmpty(this.state.accessRoutes) ? (
			<Container fluid>
				<Switch>
					{this.state.accessRoutes.map((route, idx) => {
						return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
							<route.component {...props} />
						)} />)
							: (null);
					},
					)}
					<Redirect from="/" to="/dashboard" />
				</Switch>
			</Container>
		) : [];
		const token = cookie.load('token');
		const isPasswordLink = (this.props.location.pathname === '/password/forgot') || (this.props.location.pathname === '/password/reset');

		if (isEmpty(token) && isPasswordLink === true) {
			return routeContainer;
		}
		if (isEmpty(token) && isPasswordLink === false) {
			return <Redirect from="/" to="/login" />
		}
		if (this.state.isLogout) {
			removeCookies();
			return <Redirect to="/login" />
		}

		return (
			<div className="app">
				<IdleTimer
					ref={ref => { this.idleTimer = ref }}
					element={document}
					onActive={this.onActive}
					onIdle={this.onIdle}
					onAction={this.onAction}
					debounce={250}
					timeout={this.state.timeout}
				/>
				<AppHeader fixed>
					<DefaultHeader />
				</AppHeader>
				<div className="app-body">
					<AppSidebar fixed display="lg">
						<AppSidebarHeader />
						<AppSidebarForm />
						<AppSidebarNav navConfig={this.state.accessNavs} {...this.props} />
						<AppSidebarFooter />
						{/* <AppSidebarMinimizer /> */}
					</AppSidebar>
					<main className="main">
						{!isEmpty(this.state.accessRoutes) && <AppBreadcrumb appRoutes={this.state.accessRoutes} />}
						{routeContainer}
					</main>
					<AppAside fixed hidden>
						<DefaultAside />
					</AppAside>
				</div>
				<AppFooter>
					<DefaultFooter />
				</AppFooter>
			</div>
		);
	}
}

export default DefaultLayout;
